import { defineComponent as _defineComponent } from 'vue';
import { TooltipTrigger } from "reka-ui";
export default /*@__PURE__*/ _defineComponent({
    __name: 'TooltipTrigger',
    props: {
        asChild: { type: Boolean, required: false },
        as: { type: [String, Object], required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, get TooltipTrigger() { return TooltipTrigger; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
